module.exports = __webpack_public_path__ + "img/7-1.9f7da515.png";